import { PRODUCT_TYPES } from '@/stores/product'

export const SPECS_THEMES = {
  dark: 'dark',
  white: 'white',
}

export const SPECS_PRODUCT_TYPES = {
  [PRODUCT_TYPES.shoes]: PRODUCT_TYPES.shoes,
  [PRODUCT_TYPES.apparel]: PRODUCT_TYPES.apparel,
}

export const SPECS_URL_PARAM = 'specs'

export const SPECS_LOADING_WAIT_TIME = 600

export const SPECS_MODELS = {
  [PRODUCT_TYPES.shoes]: [
    { text: 'Cloud', value: 'cloud' },
    // { text: 'Cloud 50 | 50', value: 'cloud-50-50' },
    // { text: 'Cloud 70 | 30', value: 'cloud-70-30' },
    // { text: 'Cloud Beam', value: 'cloud-beam' },
    { text: 'Cloud Dip', value: 'cloud-dip' },
    { text: 'Cloud Hi', value: 'cloud-hi' },
    { text: 'Cloud Hi Edge', value: 'cloud-hi-edge' },
    // { text: 'Cloud Hi Monochrome', value: 'cloud-hi-monochrome' },
    { text: 'Cloud Hi Waterproof', value: 'cloud-hi-waterproof' },
    { text: 'Cloud Monochrome', value: 'cloud-monochrome' },
    { text: 'Cloud Nexus', value: 'cloud-nexus' },
    { text: 'Cloud Terry', value: 'cloud-terry' },
    { text: 'Cloud Waterproof', value: 'cloud-waterproof' },
    { text: 'Cloud X', value: 'cloud-x' },
    { text: 'Cloud x Shift', value: 'cloud-x-shift' },
    { text: 'Cloudace', value: 'cloudace' },
    { text: 'Cloudaway', value: 'cloudaway' },
    { text: 'Cloudaway Kanazawa', value: 'cloudaway-kanazawa' },
    { text: 'Cloudboom', value: 'cloudboom' },
    { text: 'Cloudboom Echo', value: 'cloudboom-echo' },
    { text: 'Cloudflash', value: 'cloudflash' },
    { text: 'Cloudflow', value: 'cloudflow' },
    { text: 'Cloudflow Wide', value: 'cloudflow-wide' },
    { text: 'Cloudflyer', value: 'cloudflyer' },
    { text: 'Cloudflyer Waterproof', value: 'cloudflyer-waterproof' },
    { text: 'Cloudflyer Wide', value: 'cloudflyer-wide' },
    { text: 'Cloudnova', value: 'cloudnova' },
    { text: 'Cloudnova Wrap', value: 'cloudnova-wrap' },
    { text: 'Cloudridge', value: 'cloudridge' },
    { text: 'Cloudrock Edge Raw', value: 'cloudrock-edge-raw' },
    { text: 'Cloudrock Waterproof', value: 'cloudrock-waterproof' },
    // { text: 'Cloudrush', value: 'cloudrush' },
    { text: 'Cloudstratus', value: 'cloudstratus' },
    { text: 'Cloudsurfer', value: 'cloudsurfer' },
    { text: 'Cloudsurfer 6', value: 'cloudsurfer-6' },
    { text: 'Cloudswift', value: 'cloudswift' },
    { text: 'Cloudultra', value: 'cloudultra' },
    { text: 'Cloudventure', value: 'cloudventure' },
    { text: 'Cloudventure Peak', value: 'cloudventure-peak' },
    { text: 'Cloudventure Waterproof', value: 'cloudventure-waterproof' },
    { text: 'The ROGER Centre Court', value: 'theroger-centre-court' },
    { text: 'The ROGER Advantage', value: 'theroger-advantage' },
    { text: 'The ROGER Clubhouse', value: 'theroger-clubhouse' },
    // { text: 'THE ROGER Clubhouse Prerelease', value: 'theroger-clubhouse-prerelease' },
  ],
  [PRODUCT_TYPES.apparel]: [
    { text: 'Active Tank ', value: 'active-tank' },
    { text: 'Active-T', value: 'active-t' },
    { text: 'Active-T Breathe ', value: 'active-t-breathe' },
    { text: 'Active-T Flow ', value: 'active-t-flow' },
    { text: 'Comfort Long-T', value: 'comfort-long-t' },
    { text: 'Hoodie', value: 'hoodie' },
    { text: 'Hybrid Shorts', value: 'hybrid-shorts' },
    { text: 'Insulator Jacket', value: 'insulator-jacket' },
    { text: 'Lightweight Shorts', value: 'lightweight-shorts' },
    { text: 'On-T', value: 'on-t' },
    { text: 'Performance Long-T', value: 'performance-long-t' },
    { text: 'Performance-T', value: 'performance-t' },
    { text: 'Race Shorts', value: 'race-shorts' },
    { text: 'Running Pants', value: 'running-pants' },
    { text: 'Running Shorts', value: 'running-shorts' },
    { text: 'Sweat Pants', value: 'sweat-pants' },
    { text: 'Swiss Legacy Jacket', value: 'swiss-legacy-jacket' },
    { text: 'Tank-T', value: 'tank-t' },
    { text: 'Tights 7/8', value: 'tights-7-8' },
    { text: 'Tights Long', value: 'tights-long' },
    { text: 'Trail Breaker', value: 'trail-breaker' },
    { text: 'Waterproof Anorak', value: 'waterproof-anorak' },
    { text: 'Waterproof Pants', value: 'waterproof-pants' },
    { text: 'Waterproof Shorts', value: 'waterproof-shorts' },
    { text: 'Weather Jacket', value: 'weather-jacket' },
    { text: 'Weather Shirt', value: 'weather-shirt-2019' },
    { text: 'Weather Vest', value: 'weather-vest' },
  ],
  [PRODUCT_TYPES.accessories]: [
    { text: '5 Panel Cap', value: 'five-panel-cap' },
    // { text: 'Beoplay E8 Sport On Edition', value: 'beoplay-e8-sport' },
    { text: 'Crew Cap', value: 'crew-cap' },
    { text: 'High Sock', value: 'high-sock' },
    { text: 'Lightweight Cap', value: 'lightweight-cap' },
    { text: 'Low Sock', value: 'low-sock' },
    { text: 'Merino Beanie', value: 'merino-beanie' },
    { text: 'Mid Sock', value: 'mid-sock' },
    // { text: 'On Pack', value: 'on-pack' },
  ],
}

export const SPECS_MEASURES = {
  us: {
    unitLength: 'in',
    unitWeight: 'oz',
    conversionFactorLength: 1 / 25.4,
    conversionFactorWeight: 1 / 28.35,
  },
  default: {
    unitLength: 'mm',
    unitWeight: 'g',
  },
}

export const SPECS_CONDITIONS = {
  cold: 'cold',
  moderate: 'moderate',
  warm: 'warm',
  rain: 'rain',
}

export const SPECS_DEFAULT_ORDER = {
  shoes: {
    // "waterproof" not listed even tough present in shoe specs as we have the specific waterproof field
    activity: {
      pad: 0,
      running: 1,
      hiking: 2,
    },
    surface: {
      road: 0,
      trail: 2,
      'light-trail': 1,
    },
    usage: {
      road: 0,
      indoor: 1,
      trail: 2,
    },
    distance: {
      short: 0,
      medium: 1,
      long: 2,
    },
    cushioning: {
      max: 2,
      direct: 0,
      moderate: 1,
    },
    stability: {
      stable: 1,
      neutral: 0,
    },
    style: {
      low: 0,
      mid: 1,
      high: 2,
    },
    lacing: {
      standard: 0,
      speed: 1,
    },
    width: {
      normal: 0,
      wide: 1,
    },
    condition: {
      warmer: 0,
      cooler: 1,
    },
    competition: {
      yes: 0,
      no: 1,
    },
    support: {
      agile: 0,
      stable2: 1,
    },
  },
  apparel: {
    fit: {
      fitted: 2,
      relaxed: 0,
      athletic: 1,
    },
    activity: {
      mixed: 1,
      'daily-wear': 0,
      competition: 2,
    },
    environment: {
      mixed: 1,
      trail: 2,
      urban: 0,
    },
  },
}
